import { apiGet } from "@redriver/cinnamon";

const ActionTypes = {
  ValidateSheetForApproval: "SHEETS/VALIDATE_FOR_APPROVAL",
};

export const validateSheetForApproval = ({ sheetId, isDocuSign }) =>
  apiGet(ActionTypes.ValidateSheetForApproval, `sheets/validate-for-approval`, {
    sheetId,
    isDocuSign,
  });
